<div id="about_us_modal" class="know-more-sections">
    <div class="km-close-btn" (click)="Close()" >
        <span class="clicktoclose"><i class="icon-k-close"></i></span>
    </div>
    <div class="km-gia-rang">
        <div class="container">
            <div class="row">
                <div class="gr-content-row bt-0" style="padding-top: 0;">
                    <div class="grc-txt">
                        <h5><b>The dream of 4 visionaries</b></h5>
                        <p>The journey of NAROLA DIAMONDS PVT. LTD. began back in the year 1980 when four brothers from a small village in Gujarat came together with a dream – to make a mark in the diamond industry. Three decades later, NAROLA DIAMONDS PVT. LTD. is not only an established name in the diamond industry, it’s much more!
                        </p>
                        <p>We have grown exponentially – from a small unit in Surat to globally serving customers across 20 countries
                        </p>
                        <p>
                            We have built a strong foundation – trust, integrity and transparency remain our key values The most valuable thing we have earned in this journey – a lifelong relationship with our partners, stake holders and our esteemed customers.
                        </p>
                    </div>
                </div>
                <div class="gr-content-row">
                    <div class="grc-txt">
                        <h5><b>The mission to make a difference</b></h5>
                        <p>Our success has always been driven by the willingness to evolve, to adapt to the needs of the environment, to embrace ways where we can protect the environment - both for today’s generation and the future generation. We have always lived up to our promise of offering diamonds that have been carefully selected for their ethical and environmentally responsible origins. You could say, protecting the environment is no more philosophy for us, it is who we are.
                        </p>
                    </div>
                </div>
                <div class="gr-content-row">
                    <div class="grc-txt">
                        <h5><b>The promise to serve the “Customer” first</b></h5>
                        <p>Creating value for our customers has always been our primary motto. The ability to offer the widest range of polished goods, and also deliver the highest standards on every front has helped us gain customer trust and build a long term relationship with them. Our commitment to providing them “the best” makes all the difference.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>